import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { useCookieConsent } from '../context/CookieConsentContext';
import { useSound } from '../context/SoundContext';

const CookieBanner = () => {
  const { t } = useLanguage();
  const { hasConsent, acceptAll, rejectOptional, openPreferences } = useCookieConsent();
  const { playSound } = useSound();

  if (hasConsent) return null;

  const handleAcceptAll = () => {
    playSound?.('click');
    acceptAll();
  };

  const handleReject = () => {
    playSound?.('click');
    rejectOptional();
  };

  const handleCustomize = () => {
    playSound?.('click');
    openPreferences();
  };

  return (
    <div className="cookie-banner" role="dialog" aria-label={t('gdpr.bannerTitle')}>
      <div className="cookie-banner-inner football-card glass-football">
        <div className="cookie-banner-content">
          <h3 className="cookie-banner-title">{t('gdpr.bannerTitle')}</h3>
          <p className="cookie-banner-text">{t('gdpr.bannerDescription')}</p>
        </div>
        <div className="cookie-banner-actions">
          <button
            type="button"
            className="cookie-banner-btn cookie-banner-btn-secondary"
            onClick={handleReject}
          >
            {t('gdpr.rejectOptional')}
          </button>
          <button
            type="button"
            className="cookie-banner-btn cookie-banner-btn-outline"
            onClick={handleCustomize}
          >
            {t('gdpr.customize')}
          </button>
          <button
            type="button"
            className="cookie-banner-btn btn-football"
            onClick={handleAcceptAll}
          >
            {t('gdpr.acceptAll')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
